export default __webpack_public_path__ + "static/media/img9.2e1f8da6.png";